











































































































































































































import ModalContainer from "@/components/ModalContainer.vue"
import {EnvConfig, getEnvConfigStatusUpdate, setEnvConfig} from "@/data/repos/envConfig"
import {computed, defineComponent, onBeforeUnmount, reactive} from "@vue/composition-api"

export default defineComponent({
  components: {ModalContainer},
  props: {},
  setup(props, ctx) {
    // props.formValues
    const state = reactive({
      formValues: {} as EnvConfig,
      progress: false,
      statusMessage: "",
      updateTimer: 0,
      jobId: "",
      errorMessage: "",
      finished: false,
    })

    onBeforeUnmount(() => {
      if (state.updateTimer) {
        clearInterval(state.updateTimer)
      }
    })

    async function updateEnvConfig(environmentId: string) {
      // TODO: add initial config load if editing env config
      // console.log('updateEnvConfig')
      // const ec = await getEnvConfig(environmentId)
      // if (ec && ec.errorMessage === undefined) {
      //   Object.assign(state.formValues, ec)
      // }
      Object.assign(state.formValues, {
        dbValidationEnabled: false,
        authEnabled: true,
        authServiceVersion: "stable",
        authWebVersion: "stable",
        portalsEnabled: true,
        portalsVersion: "stable",
        macEnabled: true,
        macServiceVersion: "stable",
        macIprEnabled: true,
        macFmEnabled: true,
        macAuditEnabled: true,
        macWebVersion: "stable",
        auditTrailEnabled: true,
        auditTrailVersion: "stable",
      })
      console.log(JSON.stringify(state.formValues, null, 1))
    }

    updateEnvConfig("micad-sandbox") // todo

    async function jobStatusChecker() {
      const status = await getEnvConfigStatusUpdate(state.jobId)
      if (status) {
        if (status.errorMessage) {
          state.errorMessage = status.errorMessage
          clearInterval(state.updateTimer)
          state.progress = false
          return
        }
        state.statusMessage = status.currentAction
        if (!status.inProgress) {
          state.progress = false
          state.finished = true
        }
      }
    }

    async function submitEnvironment() {
      try {
        const response = await setEnvConfig(state.formValues)
        state.jobId = response.id || ""
        state.progress = true
        state.errorMessage = ""
        state.statusMessage = `Submitting new environment (${state.formValues.environmentId})`
        if (response && response.errorMessage) {
          state.statusMessage = response.errorMessage || ""
          state.progress = false
        } else {
          state.updateTimer = setInterval(jobStatusChecker, 500)
        }
      } catch (e) {
        state.errorMessage = e
        state.progress = false
      }
    }

    const getTitle = computed(() => {
      if (state.progress) {
        return `Creating environment ${state.formValues.environmentId}`
      } else if (state.finished) {
        return `Created environment ${state.formValues.environmentId}`
      } else {
        return "Create environment"
      }
    })

    return {state, submitEnvironment, getTitle}
  },
})
